import React from 'react';
import axios from 'cccisd-axios';
import notification from 'cccisd-notification';
import moment from 'moment';
import { Formik, Form, Field, CccisdInput, CccisdDatepicker } from 'cccisd-formik';
import style from './style.css';

const Boilerplate = window.cccisd.boilerplate;

const DeploymentEdit = ({ row, closeModal, onSuccess, allowOpenDateEdit = false }) => {
    const handleSubmit = async values => {
        try {
            const payload = {
                label: values.eventDetails,
                closesAt: values.closesOn ? moment(values.closesOn).utc().toString() : null,
            };

            if (allowOpenDateEdit) {
                payload.opensAt = values.opensOn ? moment(values.opensOn).utc().toString() : null;
            }

            const response = await axios.put(
                Boilerplate.route('api.assignmentDeployment.update', {
                    deploymentId: row.deploymentId,
                }),
                payload
            );

            if (response?.data?.errors) {
                throw response.data.errors;
            }

            if (closeModal) {
                closeModal();
            }

            if (onSuccess) {
                await onSuccess();
            }

            notification({
                message: 'Link details updated successfully.',
                type: 'success',
            });
        } catch (error) {
            let errorMessage = 'Unable to update link details.';

            if (error instanceof Error) {
                errorMessage = error.message;
            } else if (Array.isArray(error)) {
                errorMessage = error.join(', ');
            } else if (error && typeof error === 'object') {
                errorMessage = Object.values(error).join(', ');
            }

            notification({ message: errorMessage, type: 'danger' });
            throw error;
        }

        return values;
    };

    const validate = values => {
        const errors = {};

        if (!values.eventDetails) {
            errors.eventDetails = 'Event Details is required';
        }

        if (allowOpenDateEdit && !values.opensOn) {
            errors.opensOn = 'Opens On date is required';
        }

        if (allowOpenDateEdit && values.opensOn && new Date(values.opensOn) < new Date()) {
            errors.opensOn = 'Opens On date cannot be in the past.';
        }

        if (values.closesOn && new Date(values.closesOn) < new Date()) {
            errors.closesOn = 'Closes On date cannot be in the past.';
        }

        if (
            allowOpenDateEdit &&
            values.opensOn &&
            values.closesOn &&
            new Date(values.closesOn) < new Date(values.opensOn)
        ) {
            errors.closesOn = 'Closes On date cannot be before Opens On date.';
        }

        return errors;
    };

    return (
        <Formik
            initialValues={{
                eventDetails: row.label || '',
                opensOn: row.opensAt || '',
                closesOn: row.closesAt || '',
            }}
            onSubmit={handleSubmit}
            validate={validate}
            render={() => (
                <Form>
                    <Field
                        name="eventDetails"
                        component={CccisdInput}
                        label={<span className={style.required}>Event Details</span>}
                        type="text"
                    />
                    {allowOpenDateEdit && (
                        <Field
                            name="opensOn"
                            component={CccisdDatepicker}
                            placeholder="Pick date & time"
                            showTimeSelect
                            label={<span className={style.required}>Opens On</span>}
                        />
                    )}
                    <Field
                        name="closesOn"
                        component={CccisdDatepicker}
                        placeholder="Pick date & time"
                        showTimeSelect
                        label="Closes On"
                    />
                    <div className="d-flex justify-content-between" style={{ marginTop: '15px' }}>
                        <button className="btn btn-secondary" type="button" onClick={closeModal}>
                            Cancel
                        </button>
                        <button className="btn btn-primary" type="submit">
                            Save
                        </button>
                    </div>
                </Form>
            )}
        />
    );
};

export default DeploymentEdit;
